/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RiskPresetMatch = {
  /**
   * Fit between 0 and 1.
   */
  confidence: number;
  /**
   * Preset label.
   */
  label: string;
  /**
   * Preset identifier.
   */
  presetId: string;
};

/** @internal */
export const RiskPresetMatch$inboundSchema: z.ZodMiniType<
  RiskPresetMatch,
  unknown
> = z.pipe(
  z.object({
    confidence: z.number(),
    label: z.string(),
    preset_id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "preset_id": "presetId",
    });
  }),
);

export function riskPresetMatchFromJSON(
  jsonString: string,
): SafeParseResult<RiskPresetMatch, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RiskPresetMatch$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RiskPresetMatch' from JSON`,
  );
}
